import { render, staticRenderFns } from "./BindClientModal.vue?vue&type=template&id=d205bb60&scoped=true&"
import script from "./BindClientModal.vue?vue&type=script&lang=js&"
export * from "./BindClientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d205bb60",
  null
  
)

export default component.exports